// extracted by mini-css-extract-plugin
export default {"dashboardSettings":"styles_dashboardSettings__vdHLQ","layout":"styles_layout__exf+D"};